import request from '@/axios/index.js'
const subuser = '/subuser/';
const uri = '/subuser/role/';
export function getPermisson(data) {
    return request.axios({
        type:'get',
        url: uri+'query'
    })
}
export function userPageApi(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        type:'post',
        url: subuser+'page'
    })
}
export function roleApi(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        type:'get',
        url: subuser+'role'
    })
}
export function resetApi(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        type:'post',
        url: subuser+'reset'
    })
}
export function saveUserApi(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        type:'post',
        url: subuser+'save',
    })
}
export function updateUserApi(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        type:'post',
        url: subuser+'update',
    })
}
export function resetUserApi(data,loading) {
    return request.axios({
        data:data,
        loading:loading,
        type:'post',
        url: subuser+'reset'
    })
}



// WEBPACK FOOTER //
// ./src/api/role.js